// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"3872bbcf","221":"3872bbcf","480":"ae475435","641":"3872bbcf"}[chunkId] + ".chunk.css";
};